export default "__VITE_ASSET__Cw99kEao__"